import { configureStore } from "@reduxjs/toolkit";

import {
  profileReducer,
  login,
  youLoggedOut,
  youQuit,
} from "./slices/profileSlice";
import {
  playersReducer,
  setPlayers,
  playerReadied,
  playerUnreadied,
  playerConnected,
  playerDisconnected,
  playerJoined,
  boxMarked,
  playerQuit,
} from "./slices/playersSlice";
import {
  displayReducer,
  setDisplayMode,
  DisplayMode,
  lockModalHidden,
  disconnectModalEnabled,
  disconnectModalDisabled,
} from "./slices/displaySlice";
import {
  gameReducer,
  setGame,
  startGame,
  playerPassed,
  diceRolled,
  turnAdvanced,
  phaseAdvanced,
  gameEnded,
  colorLocked,
} from "./slices/gameSlice";
import {
  historicLeaderboardReducer,
  setHighScores,
  setLowScores,
} from "./slices/historicLeaderboardSlice";
import {
  endGameLeaderboardReducer,
  setEndGameLeaderboard,
} from "./slices/endGameLeaderboardSlice";

import { useAppDispatch, useAppSelector } from "./hooks";

import { setSession } from "./actions";

const store = configureStore({
  reducer: {
    profile: profileReducer,
    players: playersReducer,
    display: displayReducer,
    game: gameReducer,
    historicLeaderboard: historicLeaderboardReducer,
    endGameLeaderboard: endGameLeaderboardReducer,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
export {
  store,
  login,
  setPlayers,
  playerReadied,
  playerUnreadied,
  playerConnected,
  playerDisconnected,
  playerJoined,
  playerQuit,
  youLoggedOut,
  youQuit,
  boxMarked,
  turnAdvanced,
  phaseAdvanced,
  setDisplayMode,
  setGame,
  startGame,
  playerPassed,
  diceRolled,
  setSession,
  useAppDispatch,
  useAppSelector,
  DisplayMode,
  gameEnded,
  colorLocked,
  lockModalHidden,
  disconnectModalEnabled,
  disconnectModalDisabled,
  setHighScores,
  setLowScores,
  setEndGameLeaderboard,
};
